// export default Header;

import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
// import logo from "../../assets/images/teamlogo.png";
import logo from '../../assets/images/logo.svg'
import { TiArrowSortedDown } from "react-icons/ti";
import { FaLocationDot } from "react-icons/fa6";
import { FaMobileRetro } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagramSquare } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa6";
import Contactus from "../../pages/Contactus/Contactus";



const Header = () => {
  const location = useLocation();
  // console.log("loc", location.pathname);
  const [menuIcon, setMenuIcon] = useState(false);
  const handleSmallerScreen = () => {
    setMenuIcon(!menuIcon);
  };

  const [openDropdown, setOpenDropdown] = useState(null);

  const handleMouseEnter = (dropdown) => {
    setOpenDropdown(dropdown);
  };

  const handleMouseLeave = () => {
    setOpenDropdown(null);
  };

  const handleClick = () => {
    setOpenDropdown(null);
  };

  // const isActive = (path) => {
  //   return pathname === path ? "border-b-2 border-[#23D768]" : "";
  // };

  // const isServicesActive = (path) => {
  //   return pathname.startsWith(path) ? "border-b-2 border-[#23D768]" : "";
  // };

  //=========== mobile view dropdwon logic===================================

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleDropdownToggle = (dropdown) => {
    setIsDropdownOpen(isDropdownOpen === dropdown ? null : dropdown);
  };

  //=========== mobile view dropdwon logic end===================================

  return (
    <>
      <div className="bg-brand-gradient p-1">
        <div className="hidden lg:block w-full xl:container">
          <div className="flex items-center justify-between">
            <div className="">
              <div className="flex space-x-7">
                <div className="flex items-center">
                  <FaLocationDot className="text-[#000000a3] text-[18px] font-bold" />
                  <Link className="ml-1 text-[13px]">Aspin Commercial Tower, Dubai</Link>
                </div>
                <div className="flex items-center">
                  <FaMobileRetro className="text-[#000000a3] text-[18px] font-bold" />
                  <Link to="tel:+971554812897" className="ml-1 text-[13px]">
                    +971 55 481 2897</Link>
                </div>
                <div className="flex items-center">
                  <MdEmail className="text-[#000000a3] text-[18px] font-bold" />
                  <Link to="mailto:info@dewaapproval.ae" className="ml-1 text-[13px]">info@dewaapproval.ae</Link>
                </div>
              </div>
            </div>
            <div className="flex items-center space-x-1">
              <div className="flex items-center">
                <div className="p-1 rounded-full bg-[#000000a3]">
                  <Link
                    to="https://www.facebook.com/share/1M43n9Xwgg/?mibextid=wwXIfr"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaFacebookF className="text-[#ffffffb5] text-[12px] font-bold" />
                  </Link>
                </div>
              </div>
              <div className="flex items-center">
                <div className=" p-1 rounded-full bg-[#000000a3]">
                  <Link
                    to="https://www.instagram.com/dewaapproval.ae?igsh=MWdya2RkdWY1MXdtaw=="
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaInstagramSquare className="text-[#ffffffb5] text-[12px] font-bold" />
                  </Link>
                </div>
              </div>
              <div className="flex items-center">
                <div className="p-1 rounded-full bg-[#000000a3]">
                  <Link
                    to="https://x.com/mvts_dxb?s=11"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaTwitter className="text-[#ffffffb5] text-[12px] font-bold" />
                  </Link>
                </div>
              </div>
              <div className="flex items-center">
                <div className="p-1 rounded-full bg-[#000000a3]">
                  <Link
                    to="https://www.linkedin.com/in/megavolt-technical-service-co-llc-1703202a2?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLinkedinIn className="text-[#ffffffb5] text-[12px] font-bold" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <header className="sticky left-0 top-0 z-40 w-full duration-300 ease-in bg-black/90 backdrop-blur-md border-b border-primary/20 shadow-lg">
        <nav className="relative xl:container mx-auto">
          <div className="flex items-center justify-between p-2 hidden lg:flex">
            <div className="flex my-3">
              <Link to="/">
                <img src={logo} width={200} height={100} alt="approval logo" />
              </Link>
            </div>
            <div className="hidden lg:flex lg:gap-x-12">
              <ul className="flex xl:gap-10 md:gap-4 font-outfit items-center justify-center">
                <li className="">
                  <Link
                    to="/"
                    className={`text-white hover:text-primary transition-colors duration-300 text-lg inline-block`}
                  >
                    Home
                  </Link>
                </li>
                <li className="">
                  <Link
                    to="/aboutus"
                    className={`text-white hover:text-primary transition-colors duration-300 text-lg inline-block`}
                  >
                    About Us
                  </Link>
                </li>
                <li
                  className="relative group"
                  onMouseEnter={() => handleMouseEnter("services")}
                  onMouseLeave={handleMouseLeave}
                >
                  <button
                    className={`text-white hover:text-primary transition-colors duration-300 text-lg pb-[20px] mb-[-24px]`}
                  >
                    <div className="flex items-center">
                      <span className="mr-1">Services</span>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="rotate-90 mt-1"
                      >
                        <path
                          d="M9 5L15 12L9 19"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </button>
                  {openDropdown === "services" && (
                    <ul className="absolute bg-gray-900/95 backdrop-blur-md mt-2 top-[40px] border-t-2 border-primary w-[250px] shadow-xl rounded-b-lg">
                      <li
                        className="px-4 py-2 hover:bg-gray-800 hover:text-primary transition-colors capitalize"
                        onClick={handleClick}
                      >
                        <Link
                          to="/electricalinstallation"
                          className="text-white block hover:text-primary"
                        >
                          Electrical Installation
                        </Link>
                      </li>
                      <li
                        className="px-4 py-2 hover:bg-gray-800 hover:text-primary transition-colors capitalize"
                        onClick={handleClick}
                      >
                        <Link
                          to="/modifications"
                          className="text-white block hover:text-primary"
                        >
                          Modifications
                        </Link>
                      </li>
                      <li
                        className="px-4 py-2 hover:bg-gray-800 hover:text-primary transition-colors capitalize"
                        onClick={handleClick}
                      >
                        <Link
                          to="/powerupgrades"
                          className="text-white block hover:text-primary"
                        >
                          Power Upgrades
                        </Link>
                      </li>
                      <li
                        className="px-4 py-2 hover:bg-gray-800 hover:text-primary transition-colors capitalize"
                        onClick={handleClick}
                      >
                        <Link
                          to="/electricalsolutions"
                          className="text-white block hover:text-primary"
                        >
                          Electrical Solutions
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
                <li className="">
                  <Link
                    to="/evcharger"
                    className={`text-white hover:text-primary transition-colors duration-300 text-lg inline-block`}
                  >
                    EV Charger
                  </Link>
                </li>
                <li>
                  <Link
                    to="/blog"
                    className={`text-white hover:text-primary transition-colors duration-300 text-lg inline-block`}
                  >
                    Blog
                  </Link>
                </li>
                <li>
                  <Link
                    to="/projects"
                    className={`text-white hover:text-primary transition-colors duration-300 text-lg inline-block`}
                  >
                    Projects
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contactus"
                    className={`text-white hover:text-primary transition-colors duration-300 text-lg inline-block`}
                  >
                    Contact
                  </Link>
                </li>



              </ul>
            </div>

          </div>

          <div className="flex w-full justify-between items-center p-4 lg:hidden bg-black/95 backdrop-blur-lg border-b border-primary/20">
            <div className="">
              <Link to="/">
                <img src={logo} width={150} height={100} alt="approval logo" />
              </Link>
            </div>
            <div>
              {menuIcon ? (
                <button
                  onClick={handleSmallerScreen}
                  type="button"
                  className="collapse-icon flex flex-none rounded-full border border-[#dfdfdf] p-2 hover:text-primary ltr:ml-2 rtl:mr-2 dark:bg-dark/40 dark:text-[#d0d2d6] dark:hover:bg-dark/60 dark:hover:text-primary lg:hidden"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="m-auto h-5 w-5"
                  >
                    <path
                      d="M13 19L7 12L13 5"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      opacity="0.5"
                      d="M16.9998 19L10.9998 12L16.9998 5"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              ) : (
                <div className="flex items-center">
                  <button
                    onClick={handleSmallerScreen}
                    type="button"
                    className="collapse-icon flex flex-none rounded-full border border-[#dfdfdf] p-2 hover:text-primary ml-2 dark:bg-dark/40 dark:text-[#d0d2d6] dark:hover:bg-dark/60 dark:hover:text-primary lg:hidden"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="text-white"
                    >
                      <path
                        d="M20 7L4 7"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      />
                      <path
                        opacity="0.5"
                        d="M20 12L4 12"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      />
                      <path
                        d="M20 17L4 17"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      />
                    </svg>
                  </button>
                </div>
              )}
            </div>
          </div>

          <div
            className={
              menuIcon
                ? "fixed bottom-0 left-0 right-0 top-[0px] flex h-screen w-full bg-[#091a2c] text-white duration-300 ease-in lg:hidden"
                : "fixed left-[-100%] right-0 top-[0px] flex h-screen w-full bg-slate-900 text-white duration-300  ease-in lg:hidden"
            }
          >
            <div className="relative w-full p-4 pt-8 h-[100vh]">
              <div className=" flex items-center justify-between">
                <div className="">
                  <Link to="/">
                    <img src={logo} width={150} height={100} alt="approval logo" />
                  </Link>
                </div>
                <div onClick={handleSmallerScreen} className="">
                  {menuIcon && (
                    <button
                      type="button"
                      className="border border-[#e9e9e9] collapse-icon flex flex-none rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-primary ltr:ml-2 rtl:mr-2 dark:bg-dark/40 dark:text-[#d0d2d6] dark:hover:bg-dark/60 dark:hover:text-primary lg:hidden"
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="m-auto h-5 w-5"
                      >
                        <path
                          d="M13 19L7 12L13 5"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          opacity="0.5"
                          d="M16.9998 19L10.9998 12L16.9998 5"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  )}
                </div>
              </div>

              <ul className="mt-8 flex flex-col space-y-5 text-base font-outfit p-5 border border-[#80813954] rounded-lg h-[90%]">
                <li
                  onClick={handleSmallerScreen}
                  className=" cursor-pointer lg:hidden"
                >
                  <Link to="/">Home</Link>
                </li>
                <li
                  onClick={handleSmallerScreen}
                  className=" cursor-pointer lg:hidden"
                >
                  <Link to="/aboutus">About Us</Link>
                </li>

                <li className="cursor-pointer lg:hidden">
                  <div
                    onClick={() => handleDropdownToggle("services")}
                    className="flex items-center justify-between"
                  >
                    <span>Services</span>
                    <TiArrowSortedDown />
                  </div>
                  {isDropdownOpen === "services" && (
                    <ul className="mt-2 space-y-3 w-full rounded-lg px-5 py-3 bg-white text-black">
                      <li
                        onClick={handleSmallerScreen}
                        className="cursor-pointer capitalize"
                      >
                        <Link to="/electricalinstallation" className="text-black block">
                          Electrical Installation
                        </Link>
                      </li>
                      <li
                        onClick={handleSmallerScreen}
                        className="cursor-pointer capitalize"
                      >
                        <Link to="/modifications" className="text-black block">
                          Modifications
                        </Link>
                      </li>
                      <li
                        onClick={handleSmallerScreen}
                        className="cursor-pointer capitalize"
                      >
                        <Link to="/powerupgrades" className="text-black block">
                          Power Upgrades
                        </Link>
                      </li>
                      <li
                        onClick={handleSmallerScreen}
                        className="cursor-pointer capitalize"
                      >
                        <Link to="/electricalsolutions" className="text-black block">
                          Electrical Solutions
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
                <li
                  onClick={handleSmallerScreen}
                  className="cursor-pointer lg:hidden"
                >
                  <Link to="/evcharger">EV Charger</Link>
                </li>
                <li
                  onClick={handleSmallerScreen}
                  className=" cursor-pointer lg:hidden"
                >
                  <Link to="/blog">Blog</Link>
                </li>
                <li
                  onClick={handleSmallerScreen}
                  className=" cursor-pointer lg:hidden"
                >
                  <Link to="/projects">Projects</Link>
                </li>
                <li
                  onClick={handleSmallerScreen}
                  className=" cursor-pointer lg:hidden"
                >
                  <Link to="/contactus">Contact</Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>

      </header>

    </>

  );
};

export default Header;
